module.exports = __webpack_public_path__ + "static/media/Slide_1.f1e80f2a.png";